<div class="h-100 w-100 m-0 row bg-custom-primary overflow-auto overflow-x-hidden">

    <ng-container *ngIf="isValidToken; else showErrorMessage">
        <ng-container *ngIf="!afterChangePasswordSuccess; else changeSuccess">

            <div class="px-4 py-3 d-flex justify-content-between">
                <div class="logo">
                    <img [src]="cvaUI_url+ '/assets/images/logo.svg'" alt="logo" width="70px">
                </div>
            </div>
            <div class="login-form-wrapper d-flex justify-content-center align-items-center">

                <form *ngIf="changePasswordForm" [formGroup]="changePasswordForm" (ngSubmit)="submitForm()"
                    class="h-100 login-form w-100">
                    <div class="key d-flex justify-content-center">
                        <img class="key-img" src="assets/images/key.png" alt="key img" />
                    </div>
                    <div class="text-center">
                        <h1 class="fs-2 mb-2">Reset Your Password</h1>
                    </div>
                    <div class="mt-1 note">
                        @if(isPasswordExpired){
                        For your security, your password has expired. Please set a new one to continue.
                        }@else{
                        Create a new password for your account.
                        }
                    </div>
                    <div class="form-input">
                        <mat-form-field appearance="outline" class="">
                            <mat-label>Email</mat-label>
                            <input type="text" matInput placeholder="" formControlName="email">
                        </mat-form-field>
                    </div>

                    <div class="form-input">
                        <mat-form-field appearance="outline">
                            <mat-label>Password</mat-label>
                            <input [type]="newPasswordVisible ? 'password' : 'text'" matInput placeholder=""
                                formControlName="new_password" class="icon-input">
                            <mat-hint>
                                <img src="assets/icons/right_tick_black.svg"
                                    [ngClass]="{'filter-green': isPasswordValid()}" alt="key img" width="9px"
                                    height="10px" /> Minimum 8 characters
                            </mat-hint>
                            <mat-hint align="end">{{changePasswordForm.get('new_password')?.value.length}}/8</mat-hint>
                            <mat-error
                                *ngIf="changePasswordForm.invalid && (changePasswordForm.get('new_password')?.dirty || changePasswordForm.get('new_password')?.touched )">
                                <span *ngIf="changePasswordForm.get('new_password')?.hasError('required')">
                                    Please enter your password.
                                </span>
                            </mat-error>
                            <button type="button" class="no-button" (click)="setInputType('new')">
                                <mat-icon matSuffix>
                                    {{!newPasswordVisible ? 'visibility' : 'visibility_off'}}
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <div class="form-input mt-3">
                        <mat-form-field appearance="outline">
                            <mat-label>Confirm Password</mat-label>
                            <input [type]="cNewPasswordVisible ? 'password' : 'text'" matInput placeholder=""
                                formControlName="c_new_password" class="icon-input">
                            <mat-error
                                *ngIf="changePasswordForm.invalid  && (changePasswordForm.get('c_new_password')?.dirty || changePasswordForm.get('c_new_password')?.touched)">
                                <span *ngIf="changePasswordForm.get('c_new_password')?.hasError('required')">
                                    Please enter your password again.
                                </span>
                            </mat-error>
                            <button type="button" class="no-button" (click)="setInputType('c_new')">
                                <mat-icon matSuffix>
                                    {{!cNewPasswordVisible ? 'visibility' : 'visibility_off'}}
                                </mat-icon>
                            </button>
                        </mat-form-field>
                        <div class="mat-error"
                            *ngIf="!changePasswordForm.get('c_new_password')?.hasError('required') && (changePasswordForm.hasError('notMatched') && changePasswordForm.get('c_new_password')?.touched)">
                            Password and Confirm Password do not match.
                        </div>
                    </div>

                    <div class="mt-3">
                        <button class="form-btn" mat-stroked-button [disabled]="changePasswordForm.invalid"
                            type="submit">
                            Submit
                        </button>
                    </div>
                    <div class="remb-pass text-center bg-custom-primary m-auto start-0 end-0 mb-2">
                        <span>{{isPasswordExpired? 'Go back to ': 'Remember password? '}}</span>
                        <span class="text-secondary cursor-pointer"
                            [routerLink]="['/'+routes_constants.LOGIN]">Login</span>
                    </div>
                </form>

            </div>
        </ng-container>

        <ng-template #changeSuccess>
            <div class="login-form-wrapper d-flex justify-content-center align-items-center">
                <div class="change-successs">
                    <div class="text-center mb-4">
                        <h1 class="fs-2 mb-4">
                            Fantastic!
                            <br>
                            Password has changed successfully.
                        </h1>
                        <span class="mb-4">You're all set to login with your new credentials.</span>
                    </div>
                </div>
            </div>
        </ng-template>

    </ng-container>
    <ng-template #showErrorMessage>
        <div *ngIf="errorMessage" class="d-flex align-items-center justify-content-center error-container">
            <div class="error-box">
                <h2>Link Expired</h2>
                <div>{{errorMessage}}</div>
                <div>
                    <button class="form-btn" mat-stroked-button type="submit" (click)="generateNewLink()">
                        Generate New Link
                    </button>
                </div>
            </div>
        </div>
        <div class="position-absolute bottom-0 text-center m-auto start-0 end-0 mb-2">
            <span class="text-secondary cursor-pointer" [routerLink]="['/'+routes_constants.LOGIN]"> Go To
                Login</span>
        </div>
    </ng-template>
</div>